export default __webpack_public_path__ + "static/media/premium.803c691b.svg";